import { useVATStore } from '../../stores/VATStore';

const StepGCL = () => {
  const { error, accountNumber, setAccountNumber, sortCode, setSortCode, flow, gclFlowCompleted, gclErrors, clearError } = useVATStore();

  return (
    <div className="simple-form">
      <h2 className='ncf-title'>Your on-going safety and reassurance</h2>
      <p className='step-explain'>
        To use our alarm service and ensure your ongoing safety, please select a subscription plan and set up a Direct Debit.
        Your first month is already paid for and began when your alarm was ordered, no additional payment will be taken until it ends and your new subscription begins.
      </p>
     <>
        <div className='border-top'>
          <label className='ncf-title'>Set up your Direct Debit</label>
          <div className='form-line margin-top'>
            <div className='input-group left'>
              <input
                id="name" type="text"
                className={gclErrors.includes('account_number') ? 'input-ncf error-required' : 'input-ncf'}
                value={accountNumber ?? ''}
                onChange={(e) => { setAccountNumber(e.target.value); clearError(); }} required
              />
              <label className='placeholder'>Account Number*</label>
            </div>
            <div className='input-group right'>
              <input
                id="name" type="text"
                className={gclErrors.includes('sort_code') ? 'input-ncf error-required' : 'input-ncf'}
                value={sortCode ?? ''}
                onChange={(e) => { setSortCode(e.target.value); clearError(); }} required
              />
              <label className='placeholder'>Sort Code*</label>
            </div>
          </div>
          <div className='ts-and-cs-box'>
            By clicking 'Pay in Gocardless', I confirm that I am over 18, and that I have read and accept the <a href='https://careline.co.uk/pages/terms-and-conditions' target='_blank'>Terms and Conditions</a> and the <a href='https://careline.co.uk/policies/privacy-policy' target='_blank'>Privacy Policy</a>.
          </div>
        </div>
      </>
      {error !== '' ? <div className="error">{error}</div> : ''}
      {flow && gclFlowCompleted ? <div>
        <div className='gcl_completed'>
          GCL registration Completed
        </div>
      </div> : ''}
    </div>
  );
};

export default StepGCL;